import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const Title = styled('div', {
  flex: 1,

  '@bp2': {
    alignSelf: 'center',
    flex: 1,
    paddingLeft: '$6',
    paddingRight: '$6',
  },

  '@bp3': {
    paddingLeft: '$11',
    paddingRight: '$11',
  },
})

export const Description = styled('div', {
  flex: 1,

  '@bp2': {
    paddingLeft: '$6',
    paddingRight: '$6',
  },

  '@bp3': {
    paddingLeft: '$11',
    paddingRight: '$11',
  },
})

export const EssentialNutrientsRoot = styled('div', {
  maxWidth: '$max',
  paddingLeft: '$2',
  paddingRight: '$2',
})

export const VerticalSeparator = styled('div', {
  width: '1px',
  backgroundColor: '$primary-800',
  height: '$7',
  alignSelf: 'center',

  '@bp2': {
    height: 'auto',
    alignSelf: 'auto',
  },
})
